module.exports = __webpack_public_path__ + "static/media/Stormy_Jealous.17ef8c22.gif";